module.exports = __webpack_public_path__ + "img/image02_sp.a8771ce9.jpg";